import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/shared/ui/organisms/PageHeader';

import { useTutorMemoryConfig } from '../../../hooks/useTutorMemoryConfig';
import { useTutorPersonaConfig } from '../../../hooks/useTutorPersonaConfig';
import { PromptConfigForm } from '../../organisms/PromptConfigForm';

/** Escopo global — constante de módulo para não recriar o objeto a cada render. */
const GLOBAL_SCOPE = { kind: 'global' } as const;

/**
 * Template da configuração global do tutor.
 *
 * Persona e memória aparecem na mesma tela porque compõem o mesmo prompt final; cada uma
 * salva sozinha, porque são dois endpoints distintos.
 */
export function TutorGlobalConfigTemplate() {
  const { t } = useTranslation('tutorAI');
  const persona = useTutorPersonaConfig(GLOBAL_SCOPE);
  const memory = useTutorMemoryConfig(GLOBAL_SCOPE);

  return (
    <div className="flex flex-col gap-xs">
      <PageHeader title={t('config.title')} subtitle={t('config.subtitle')} />

      <PromptConfigForm
        title={t('config.persona.title')}
        description={t('config.persona.description')}
        label={t('config.persona.label')}
        placeholder={t('config.persona.placeholder')}
        confirmBody={t('config.confirm.bodyGlobal')}
        inheritedMessage={t('config.notConfigured')}
        state={persona}
      />

      <PromptConfigForm
        title={t('config.memory.title')}
        description={t('config.memory.description')}
        label={t('config.memory.label')}
        placeholder={t('config.memory.placeholder')}
        confirmBody={t('config.confirm.bodyGlobal')}
        inheritedMessage={t('config.notConfigured')}
        state={memory}
      />
    </div>
  );
}
